module.exports = __webpack_public_path__ + "img/circle-7.92df0ae4.svg";